import { Button, Card } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ListVehicle from '../components/vehicle/ListVehicle';

const ManageVehiclePage = () => {

  const navigate = useNavigate();

  return (
    <Card
      title='Manage Vehicles'

      extra={<Button onClick={() => navigate('/add-vehicle')} type='primary' ghost>Add Vehicle</Button>}
    >
      <ListVehicle />

    </Card>
  )
}

export default ManageVehiclePage
